<template>

    <div style="display: flex; align-items: flex-start;">

        <div class="btn btn-default dropzone-area" style="width:100px; margin-right: 20px;">
            <div class="dropzone-response" v-if="procentage == null && dropzoneResponse == null">
                Välj fil:
            </div>
            <div class="dropzone-response" v-if="procentage != null && dropzoneResponse == null">
                Laddar {{ procentage }}%
            </div>
            <div class="dropzone-response" v-if="dropzoneResponse != null">
                Välj fil: 
            </div>
            <input type="file" v-on:change="uploadFile" style="">
        </div>

        <div style="display:flex; width:calc(100% - 120px); flex-wrap: wrap;">
            <div class="meta-file-wrapper" :class="{ 'single' : allFiles && allFiles.length < 2 }" :key="file.id" v-for="file in allFiles">
                
                <div class="meta-file">
                    <a :href="file.url" target="_blank">
                        <img src="/images/admin/file_pdf.svg" v-if="fileExtension(file.original_name) == 'pdf'">
                        <img src="/images/admin/file_img.svg" v-else>
                        <div class="meta-file-title">{{ file.original_name }}</div>
                    </a>
                    <div class="meta-file-date">{{ file.created_at.substr(0, 10) }}</div>
                    <div style="display:flex; justify-content: center;"><button class="btn btn-danger btn-sm" @click="deleteFile(file.id)">Ta bort</button></div>
                </div>

            </div>
        </div>

    </div>

</template>

<script>
export default {
    props: {
        type: {},
        clinicId: {},
        currentData: {}
    },
    data: function () {
        return {

            dropzoneResponse: null,
            procentage: null

        }
    },
    methods: {

        uploadFile: function (e) {
            const self = this

            const fileUploadFormData = new FormData()

            self.dropzoneResponse = null
            self.procentage = null

            fileUploadFormData.append('file', e.target.files[0])
            fileUploadFormData.append('type', self.type)
            fileUploadFormData.append('clinicId', self.clinicId)
            fileUploadFormData.append('meta_id', self.currentData.id)

            self.$http.post('/clinics/upload', fileUploadFormData, {

                progress: (e) => {
                    self.procentage = Math.round((e.loaded / e.total) * 100)
                }

            }).then((response) => {
                console.log(response.body)

                const file_id = response.body

                // self.allFiles = response.body;

                self.dropzoneResponse = e.target.files[0].name

                bus.$emit('uploaded-file', self.type, file_id)
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        deleteFile (file_id) {
            const self = this

            if (!confirm('Är du säker?')) {
                return
            }

            self.$http.post('/clinics/file/trash', {
                file_id: file_id
            }).then((response) => {
                console.log('got delete file response')
                console.log(response.body)

                bus.$emit('refresh-data', 1)
            }, (response) => {
                console.log(JSON.stringify(response))
            })
        },

        fileExtension(filename) {
            return filename.slice(filename.lastIndexOf('.') + 1);
        }
    },
    computed: {

        allFiles: function () {
            console.log('watching currentFiles')
            console.log(this.currentFiles)

            if (!this.currentData) {
                return null
            }

            return this.currentData.files
        }

    }

}
</script>

<style type="text/scss">

.dropzone-area {

    text-align: center;
    position: relative;
    border: 2px dashed #CBCBCB;
    cursor: pointer;
}

.dropzone-area input {
    position: absolute;
    cursor: pointer;
    top: 0px;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
}

</style>
